/* eslint-disable vue/one-component-per-file */
import Icon from '@ui/components/icon.vue';
import { defineComponent, h, mergeProps } from 'vue';

// p

export interface MessageInterface {
    text: string;
    type: string;
}
export interface BaseFormElementInterface {
    label?: string;
    labelTooltip?: {
        text?: string;
        icon?: string;
    };
    description?: string;
    name?: string;
    message?: MessageInterface;
    showMessage?: boolean;
    controlled?: boolean;
    relatedTo?: string;
    disabled?: boolean;
    dataCy?: null | string;
}

export const Description = defineComponent({
    inheritAttrs: false,
    props: {
        text: {
            type: String,
            default: '',
        },
    },
    slots: {},
    setup(props, { slots, attrs }) {
        return () =>
            h(
                'span',
                mergeProps(
                    {
                        class: 'mb-0.5 text-xs font-normal tracking-tight leading-4 font-sans text-gray-400 sm:text-sm',
                    },
                    attrs,
                ),
                slots.default ? slots.default() : props.text,
            );
    },
});

export const Label = defineComponent({
    inheritAttrs: false,
    props: {
        text: {
            type: String,
            default: '',
        },
        tooltip: {
            type: Object,
            default: () => ({ text: '', icon: '' }),
        },
    },
    setup(props, { slots, attrs }) {
        return () =>
            h(
                'span',
                mergeProps(
                    {
                        class: 'm-0 mb-1 font-sans text-base font-medium tracking-tight leading-5 flex items-center gap-1',
                    },
                    attrs,
                ),
                [
                    slots.default ? slots.default() : props.text,
                    props.tooltip.icon
                        ? h(Icon, { icon: props.tooltip.icon, tooltip: props.tooltip.text, size: 'xsmall' })
                        : null,
                ],
            );
    },
});

export const Message = defineComponent({
    inheritAttrs: false,
    props: {
        text: {
            type: String,
            default: '',
        },
        show: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'error',
        },
    },
    slots: {},
    setup(props, { slots, attrs }) {
        return () =>
            h(
                'div',
                mergeProps(
                    {
                        class: [
                            'grid',
                            'transition-all',
                            'duration-300',
                            props.show ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
                        ],
                    },
                    attrs,
                ),
                h(
                    'div',
                    {
                        class: [
                            'overflow-hidden',
                            'text-sm',
                            'font-sans',
                            props.type === 'error' ? 'text-red-600' : 'text-gray-500',
                        ],
                    },
                    h(
                        'div',
                        {
                            class: ['pt-0.5', 'tracking-tight'],
                        },
                        slots.default ? slots.default() : props.text,
                    ),
                ),
            );
    },
});
